import ltiApi from '@/services/plataforma/lti';

export default {
  async actionGetAcademicMainContentsForLTILinkGeneration(_, academicMainId) {
    return ltiApi.getAcademicMainContentsForLTILinkGeneration(academicMainId)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data.error));
  }
};
